var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRebuttalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E869272B-3ECB-4B1E-8A94-ADBAB4FFA19B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-742.000000, -464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(742.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0 C22.6568542,-3.04359188e-16 24,1.34314575 24,3 L24,14 C24,15.6568542 22.6568542,17 21,17 L16.5605152,17.0009262 C16.4750195,17.1486586 16.3690613,17.2877929 16.2426407,17.4142136 L13.4142136,20.2426407 C12.633165,21.0236893 11.366835,21.0236893 10.5857864,20.2426407 L7.75735931,17.4142136 C7.63093869,17.2877929 7.52498052,17.1486586 7.43948481,17.0009262 L3,17 C1.34314575,17 2.02906125e-16,15.6568542 0,14 L0,3 C-2.02906125e-16,1.34314575 1.34314575,1.19253761e-15 3,0 L21,0 Z",
    id: "Combined-Shape",
    fill: "#FFB647"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(11.000000, 4.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.949210133,
    x2: 1,
    y2: 4.94921013,
    id: "Path-8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB647",
    cx: 1,
    cy: 7.94921013,
    r: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebuttalIcon);
export default __webpack_public_path__ + "static/media/rebuttal-icon.287a9d1a622823ef29932eefe5c80342.svg";
export { ForwardRef as ReactComponent };